module.exports = __webpack_public_path__ + "static/img/twjd-img4.e4d638b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-img4.png
// module id = 229
// module chunks = 0